import React from 'react';

interface JumbotronProps {
  title: string;
}

export const Jumbotron: React.FC<JumbotronProps> = ({ title, children }) => {
  return (
    <div className="p-3 grey-bg rounded-3">
      <h1>{title}</h1>
      {children}
    </div>
  );
};
